/* eslint-disable @typescript-eslint/no-explicit-any */
import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type TenantInvitationCodeTenantSerializer = {
  invitationCode: string;
  tenant: Record<string, any>;
};

export type PostTenantInvitationCodeTenantPayloadType = (
  Pick<TenantInvitationCodeTenantSerializer, 'invitationCode'>
);
export type PostTenantInvitationCodeTenantResponseType = (
  Pick<TenantInvitationCodeTenantSerializer, 'tenant'>
);

export const apiFetchTenantInvitationCodeTenant = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostTenantInvitationCodeTenantPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('public');
    const res = await client.post({
      url: urls.v1.tenantInvitationCodeTenant(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
